<template>
    <RecommendedItem :title="title" v-if="shouldBeVisible">
        <CarouselCourses theme="dark" :courses="courses" />
    </RecommendedItem>
</template>

<script>
    import RecommendedItem from 'components/landingpage/RecommendedItem'
    import CarouselCourses from 'components/user/summary/carousel/CarouselCourses'
    import { mapGetters } from 'vuex'
    import { translateWithDefault } from 'helpers/i18nHelper'
    import withLanguage from 'components/landingpage/recommended-items/mixins/with-language'

    export default {
        components: { CarouselCourses, RecommendedItem },
        computed: {
            ...mapGetters({
                mostPopularCoursesInPackage: 'Courses/getMostPopularCoursesInPackage'
            }),
            courses () {
                return this.mostPopularCoursesInPackage.courses
            },
            package () {
                const { code, name } = this.mostPopularCoursesInPackage.package
                return translateWithDefault(code, name)
            },
            title () {
                return this.$t('LandingPage.recommended_items_most_popular_courses_in_topic_title', { topicname: this.package })
            },
            shouldBeVisible () {
                const { package: { code }, courses } = this.mostPopularCoursesInPackage
                return code !== null && courses.length > 0
            }
        },
        data () {
            return {
                storeUpdateContentAction: 'Courses/loadMostPopularCoursesInUsersMostPopularPackage'
            }
        },
        mixins: [withLanguage]
    }
</script>
